<template>
  <Modal
    ref="rejectResonModalRef"
    :showIcon="false"
    :clickToClose="true"
    :modalStyle="{ width: '1320px', height: '626px' }"
  >
    <template v-slot:body style="gap: 18px;">
      <div class="header">
        <p class="title">Hata Raporu</p>
        <p class="text">Gönderdiğiniz şablonda aşağıdaki <span class="fail-count">{{ failCount }} ürün</span> yüklenememiştir.</p>
      </div>
     
      <div class="info-box">
        <img width="20px" height="20px" src="@/assets/images/icons/info-circle.svg" />
        <div class="info-box-container">
          <div>
            <span>Şimdi ne yapmalıyım?</span>
            <p>Yalnızca aşağıdaki ürünler için yeni bir şablon indirin. Ürünlerin bilgilerini kontrol edip düzelttikten sonra tekrar sisteme yükleyin.</p>
          </div>
        </div>
      </div>
      <TableForRejectReason :taskId="taskId"/>
      <div class="button-container">
        <AppButton primary lg title="Raporu İndir" @click="downloadReport(taskBatchId)">
          <template #prependIcon>
            <img src="@/assets/images/icons/download.svg" alt="download" />
          </template>
        </AppButton>
      </div>
      
    </template>
  </Modal>
</template>

<script setup>
import { ref, defineExpose } from "vue";
import { Modal, AppButton } from "@n11/so-ui-components";
import TableForRejectReason from "./TableForRejectReason.vue";
import {REJECTED_REPORT_DOWNLOAD} from "@/utils/enum/endpoints";

const rejectResonModalRef = ref(null);

const failCount = ref(null);
const taskId = ref(null);
const taskBatchId = ref(null);

const openModal = (failCountValue, taskIdValue, taskBatchIdValue) => {
  failCount.value = failCountValue;
  taskId.value = taskIdValue;
  taskBatchId.value = taskBatchIdValue;
  rejectResonModalRef.value?.openModal();
};
const downloadReport = (id) => {
  const link = document.createElement('a');

  Object.assign(link, {
    href: REJECTED_REPORT_DOWNLOAD.replace('{id}', id),
    download: null,
    style: 'display: none;',
  });

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

defineExpose({
  openModal,
});

</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/utilities.scss';

.header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
}

.title {
  color: $colorN80;
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: -0.2px;
}

.text {
  color: $colorN80;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.05px;
}

.fail-count {
  color: $colorE50;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: -0.05px;
}
.info-box {
  display: flex;
  background-color: $colorB10;
  padding: 16px;
  gap: 12px;
  border-radius: 6px;

  &-container {
    display: flex;
    width: 100%;
    font-size: 13px;
    justify-content: space-between;

    span {
      font-weight: 700;
      margin-right: 640px;
    }

    p {
      margin-top: 4px;
    }
  }
}

.button-container { 
  position: absolute;
  bottom: 20px;
  right: 20px;
}
</style>
